<template>
  <div class="quest-item">
    <div class="quest-tag">
      <div :class=typeClass(item.quest_type) class="quest-type">
        {{ item.quest_type_name }}
      </div>
    </div>
    <div class="quest-tag">
      <div :class=periodClass(item.quest_period) class="quest-period">
        {{ item.quest_period_name }}
      </div>
    </div>
    <div class="quest-text">
      <span v-if="item.end_datetime!=null" class="quest-finished">終了済</span>
      <span v-else-if="item.is_limited==1" class="quest-limited">期間限定！</span>
      <span class="quest-title">{{ item.name }}</span>
      <div class="quest-description">{{ item.description }}</div>
    </div>
    <router-link :to="'/quest/'+item.quest_id">
      <a  @click="openQuestModal(); setModalQuest(item.quest_id)" class="quest-link"></a>
    </router-link>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'QuestItem',
  props: ['item'],
  methods: {
    openQuestModal: function () {
      this.$emit('openQuest')
    },
    typeClass: function (type) {
      return 'quest-type-' + type
    },
    periodClass: function (period) {
      return 'quest-period-' + period
    },
    ...mapActions([
      'setModalQuest'
    ])
  }
}
</script>

<style scoped>
.quest-item {
  display: flex;
}
.quest-tag {
  height: 78px;
  width: 78px;
  line-height: 78px;
  font-size: 20pt;
  color: #FFFFFF;
  background-image: linear-gradient(to bottom, #F26C6D, #B93B38);
  border: 1px solid #484226;
  margin-right: 8px;
}
.quest-type {
  color: #FFFFFF;
  background-image: linear-gradient(to bottom, #F26C6D, #B93B38);
  text-shadow: 0 0 4px var(--outline-color); /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px var(--outline-color); /* フォントのアウトラインを指定 */
}
.quest-type-factory {
  background-image: linear-gradient(to bottom, #56C16C, #3F7A4D);
  --outline-color: #153018;
}
.quest-type-sortie {
  background-image: linear-gradient(to bottom, #F26C6D, #B93B38);
  --outline-color: #6C120F;
}
.quest-type-exercise {
  background-image: linear-gradient(to bottom, #9CD073, #479334);
  --outline-color: #1E3813;
}
.quest-type-expedition {
  background-image: linear-gradient(to bottom, #50C6C5, #369B96);
  --outline-color: #052F2E;
}
.quest-type-supply_repair {
  background-image: linear-gradient(to bottom, #E2C873, #BF9B3F);
  --outline-color: #5B3D21;
  line-height: 39px;
}
.quest-type-arsenal {
  background-image: linear-gradient(to bottom, #946B50, #62423A);
  --outline-color: #1F0E09;
}
.quest-type-refurbishment {
  background-image: linear-gradient(to bottom, #D5AEE2, #A27EB4);
  --outline-color: #593C68;
}
.quest-period {
  color: #EED952;
  background-image: linear-gradient(to bottom, #D0D2D2, #B5B7B7);
  text-shadow: 0 0 4px var(--outline-color); /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px var(--outline-color); /* フォントのアウトラインを指定 */
}
.quest-period-daily {
  color: #71BFFD;
  --outline-color: #24364D;
}
.quest-period-weekly {
  color: #74D4E0;
  --outline-color: #2F5565;
}
.quest-period-monthly {
  color: #B7E161;
  --outline-color: #243F33;
}
.quest-period-quarterly {
  color: #DF9B61;
  --outline-color: #40382B;
}
.quest-period-yearly {
  color: #FFFFFF;
  --outline-color: #292725;
}
.quest-period-once {
  color: #EED952;
  --outline-color: #41433A;
}
.quest-text{
  flex: 1;
  height: 80px;
  text-align: left;
  color: #67615B;
  overflow-y: hidden;
}
.quest-link {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.quest-title {
  font-size: 16pt;
  font-weight: bold;
}
.quest-description {
  font-size: 12pt;
}
.quest-finished {
  font-size: 14pt;
  font-weight: bold;
  color: #FFFFFF;
  background-color: #5F5A54;
}
.quest-limited {
  font-size: 14pt;
  font-weight: bold;
  color: #FFFFFF;
  background-color: #e03333;
}
</style>



// WEBPACK FOOTER //
// src/components/manager_main/QuestItem.vue